interface AssignIconProps {
  fill?: string;
  width?: number;
  height?: number;
}

export function AssignIcon({
  fill = "currentColor",
  width = 24,
  height = 24,
}: AssignIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_assign)">
        <path
          d="M12 20L11.14 19.14C9.96 17.96 9.97 16.04 11.16 14.88L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12ZM11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12Z"
          fill={fill}
        />
        <path
          d="M16.1798 19.7788C15.7898 20.1688 15.1498 20.1688 14.7598 19.7788L12.6898 17.6888C12.3098 17.2988 12.3098 16.6787 12.6898 16.2987L12.6998 16.2888C13.0898 15.8988 13.7198 15.8988 14.0998 16.2888L15.4698 17.6588L19.8998 13.1987C20.2898 12.8088 20.9198 12.8088 21.3098 13.1987L21.3198 13.2088C21.6998 13.5988 21.6998 14.2188 21.3198 14.5988L16.1798 19.7788Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_assign">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
